var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import i18next from "i18next";
import get from "lodash/get";
import groupBy from "lodash/groupBy";
import keyBy from "lodash/keyBy";
import merge from "lodash/merge";
import set from "lodash/set";
import uniq from "lodash/uniq";
import { BeeModelManager } from "../../beeorm/BeeModelManager";
import { CART_ITEMS_PATH, ROOT_CART_ITEM_INDEX, TIMESPAN_ID_PATH, getBookersCount, getCartItemPath, getCartItemPersonalDataPath, getCartItemPriceIdPath, getCartItemQuantityPath, getComments, getParticipantsAsSelectOptions, getPriceId, getReferenceFieldPath, getSearchAndSelectName, getTimespanId, hasAllowAllEvents, onCategoryChange } from "../../components/BookingForm/booking-form.helpers";
import { BLOCK, CART_EXTRA_ITEM, CART_ITEM, CONFIRM_CANCEL_BOOKING_WRAPPER, INLINE_FIELDS, PARTICIPANT_GROUP, PARTICIPANT_GROUP_FLAT, PRICE_DESCRIPTION, REGISTER_DIFFERENT_PARTICIPANTS, STEP_META } from "../../classConstants";
import { normalizeField } from "../../components/BookingFormPage/field-meta";
import { setParticipantProps } from "../../components/BookingFormPage/wizard-steps.helper";
import { componentTypes } from "../../components/Form/componentTypes";
import { validatorTypes } from "../../components/Form/validatorTypes";
import { NoDataToDisplay } from "../../components/NoDataToDisplay/NoDataToDisplay";
import { getClassName } from "../../helpers";
import { getCustomerList } from "../../store/actions/response.actions";
import { EntitiesEnum } from "../../store/store";
import { ConsentModel, CountryModel, CourseModel, CourseTimespanModel, FormFieldModel, FormGroupModel, FormItemModel, PlaceModel, PriceModel, SalutationModel } from "./";
import { BookModel } from "./BookModel";
import { CourseTimespansQuantityStepModel } from './CourseTimespansQuantitySteps/CourseTimespansQuantityStepModel';
import { OutgoingMessageModel } from "./OutgoingMessages/OutgoingMessageModel";
import { SchedulingTimeRangeModel } from "./SchedulingTimeRange/SchedulingTimeRangeModel";
import getDate from "date-fns/getDate";
import isToday from "date-fns/isToday";
import isTomorrow from "date-fns/isTomorrow";
import parseISO from "date-fns/parseISO";
import assign from "lodash/assign";
import uniqBy from "lodash/uniqBy";
import { dateFormat, dateToString } from "../../helpers/date";
import { mergeEntities } from "./mergeEntities";
import { UserModel } from "./User/UserModel";
import { AppointmentModel } from "./Appointments/AppointmentModel";
var BookModelManager = /** @class */ (function (_super) {
    __extends(BookModelManager, _super);
    function BookModelManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BookModelManager.prototype, "ModelClass", {
        get: function () {
            return BookModel;
        },
        enumerable: false,
        configurable: true
    });
    BookModelManager.prototype.createModelManager = function (entities, options) {
        if (options === void 0) { options = {}; }
        return getBookManager(entities, __assign(__assign({}, this.options), options));
    };
    BookModelManager.prototype.courseTimespans = function () {
        return this.getCollection('course_timespans');
    };
    BookModelManager.prototype.courses = function () {
        return this.getCollection('courses');
    };
    BookModelManager.prototype.prices = function () {
        return this.getCollection('prices');
    };
    BookModelManager.prototype.places = function () {
        return this.getCollection('places');
    };
    BookModelManager.prototype.formGroups = function () {
        return this.getCollection('form_groups');
    };
    BookModelManager.prototype.formItems = function () {
        return this.getCollection('form_items');
    };
    BookModelManager.prototype.salutations = function () {
        return this.getCollection(EntitiesEnum.SALUTATIONS);
    };
    BookModelManager.prototype.outgoingMessages = function () {
        return this.getCollection(EntitiesEnum.OUTGOING_MESSAGES);
    };
    BookModelManager.prototype.schedulingTimeRanges = function () {
        return this.getCollection(EntitiesEnum.SCHEDULING_TIME_RANGES);
    };
    BookModelManager.prototype.courseParticipants = function () {
        return this.getCollection(EntitiesEnum.COURSE_PARTICIPANTS);
    };
    BookModelManager.prototype.courseAppointments = function () {
        return this.getCollection(EntitiesEnum.COURSE_APPOINTMENTS);
    };
    BookModelManager.prototype.getFixedNames = function (userFilters) {
        if (userFilters === void 0) { userFilters = {}; }
        var _a = userFilters.courses, courses = _a === void 0 ? [] : _a, _b = userFilters.places, places = _b === void 0 ? [] : _b;
        var ctCollection = this.courseTimespans();
        return {
            courses: uniq(ctCollection.getFixedCourses({ courses: courses, places: places }).all().map(function (p) { return p.get("name"); })),
            places: uniq(ctCollection.getFixedPlaces({ courses: courses, places: places }).all().map(function (p) { return p.get("name"); }))
        };
    };
    BookModelManager.prototype.getWaitingListEntityFormItem = function (form) {
        if (!form.toWaitList)
            return null;
        if (!this.options.waitListEntities)
            return null;
        return this.createModelManager(this.options.waitListEntities).getCollection('form_items').filter(function (_x, i) { return i === 0; });
    };
    BookModelManager.prototype.getEventsFormOptions = function (selections, options) {
        var _a, _b, _c;
        if (selections === void 0) { selections = {}; }
        var _d = selections.placeName, placeName = _d === void 0 ? '' : _d, _e = selections.categoryNames, categoryNames = _e === void 0 ? [] : _e;
        var price_id = getPriceId(selections);
        var allowAllEvents = hasAllowAllEvents(selections);
        var bookers_count = getBookersCount(selections) || 0;
        var timespan_id = getTimespanId(selections);
        var ctCollection = this.courseTimespans();
        var fixedFilters = this.getFixedNames({
            courses: this.options.courses,
        });
        var courses = uniq(categoryNames).filter(Boolean);
        var places = [placeName].filter(Boolean);
        var availableTimespans = ctCollection.getAvailableTimespans({}, { exclusive: false });
        var selectedTimespan = (availableTimespans.size === 1 ? availableTimespans.first() : ctCollection.findById(+timespan_id));
        var placesLeft = !selectedTimespan ? 0 : allowAllEvents ? selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.max_bookable_places_left : selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.deriveQuantityLeft({});
        var itemsMapById = keyBy(get(selections, CART_ITEMS_PATH, []), "position.price_id");
        var hasStepPricing = selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.hasStepPricing;
        var courseOptions = this.options.isAdminIntegration
            ? []
            : this.courses().getAsCategoryOptions(+options.maximum_category_dropdown_levels, courses, places);
        courseOptions = ((_a = courseOptions[0]) === null || _a === void 0 ? void 0 : _a.filter(function (option) { return !fixedFilters.courses.includes(option.value); }).length) > 0 ? courseOptions : [];
        return {
            itemsMapById: itemsMapById,
            requires_scheduling: selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.isSchedulingTimespan,
            availableTimespansCount: availableTimespans.size,
            timespansCount: ctCollection.size,
            requiresPriceSelection: hasStepPricing,
            placeOptions: this.options.isAdminIntegration ? [] : this.places().getAsSelectOptions({ value: "name" }),
            timespanOptions: this.options.showTimespanSearchAndSelect ? [] : ctCollection.getAsSelectOptions({
                placement: get(options, "placement") || "bookcart",
                label: "timespan_format",
                courses: get(this.options, "courses"),
            }),
            priceOptions: !selectedTimespan ? [] : selectedTimespan.getAvailablePrices({ quantity: bookers_count, maxQuantity: placesLeft }).getAsSelectOptions({ label: "priceAsTitleWithoutPlacesLeft" }),
            // bookingSlot should be null here.
            // If the bookingSlot is passed down, the quantity becomes dependent on the booking slot.
            bookerCountOptions: placesLeft > 0 || hasStepPricing ? (selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.getBookerCountOptions({ allowAllEvents: allowAllEvents, price_id: price_id, bookingSlot: null })) || [] : [],
            extraPrices: price_id > -1 && timespan_id > -1 && !hasStepPricing && placesLeft > 0 && bookers_count > 0 ? ((_b = selectedTimespan.customerPrices().findById(+price_id)) === null || _b === void 0 ? void 0 : _b.getExtraPricesAsSelect(Math.min(Number(placesLeft), CourseTimespanModel.MAX_BOOKABLE_PLACES), itemsMapById, price_id)) || [] : [],
            categories: courseOptions,
            schedulingDateRange: (selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.getSchedulingDates({ bookers_count: bookers_count }).map(function (dateRange) { return dateRange.from; })) || [],
            schedulingTimeRange: (selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.getSchedulingSlots({ bookers_count: bookers_count, onDate: (_c = itemsMapById[price_id]) === null || _c === void 0 ? void 0 : _c.onDate })) || [],
        };
    };
    BookModelManager.prototype.getTimespanSearchAndSelect = function (form, _a) {
        var _b;
        var _this = this;
        var _c;
        var _d = _a === void 0 ? {} : _a, _e = _d.placement, placement = _e === void 0 ? '' : _e;
        var options = [];
        try {
            options = this.courseTimespans().getAsSelectOptions({
                placement: placement || "bookcart",
                label: "timespan_format",
                courses: get(this.options, "courses"),
            });
        }
        catch (_f) { }
        var name = TIMESPAN_ID_PATH;
        return normalizeField(assign({
            title: i18next.t("bookcart.select_timespan"),
            name: TIMESPAN_ID_PATH,
            field_type_name: componentTypes.SEARCH_N_SELECT,
            is_required: true,
        }, this.options.isAdminIntegration ? {} : {
            title: i18next.t("bookcart.timespan"),
            placeholder: i18next.t("bookcart.select_timespan"),
        }), {
            isHidden: this.options.isFixedTimespan,
            showDefaultOption: !this.options.isAdminIntegration,
            // isFetchOptionsDispatchAction: true,
            labelKey: "label",
            isLoading: this.options.isLoadingBookEntities,
            hasRemoteSource: true,
            query: get(form, getSearchAndSelectName(name)),
            loadMore: (_c = (!this.options.isAdminIntegration ? this.options.loadMoreBookEntities : undefined)) !== null && _c !== void 0 ? _c : undefined,
            onQueryChange: this.options.isAdminIntegration ? undefined : function () {
                var _a, _b;
                (_b = (_a = _this.options).resetPageNumber) === null || _b === void 0 ? void 0 : _b.call(_a);
            },
            reset: (_b = {},
                _b[getCartItemQuantityPath(ROOT_CART_ITEM_INDEX)] = null,
                _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".onDate"] = null,
                _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking_slot"] = null,
                _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".bookingSlot"] = null,
                _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.from"] = null,
                _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.to"] = null,
                _b["booking_data.has_separate_bill_data"] = undefined,
                _b),
            fetchOptions: function (_a) {
                var query = _a.query;
                // const queryString = qs.stringify(pickBy({ query, is_validation_unstrict: isValidationDisabled(form) }, Boolean));
                // return getBookEntities(queryString);
            },
            options: options,
        });
    };
    BookModelManager.prototype.getEventForm = function (form, options, rootCartItemIndex) {
        var _a, _b;
        var _this = this;
        var _c, _d;
        if (options === void 0) { options = {}; }
        if (rootCartItemIndex === void 0) { rootCartItemIndex = ROOT_CART_ITEM_INDEX; }
        var deriveNameWithPrefix = function (name) { return [name].filter(Boolean).join(""); };
        var timespanId = getTimespanId(form);
        var priceId = getPriceId(form);
        var _e = this.getEventsFormOptions(form, options), requires_scheduling = _e.requires_scheduling, availableTimespansCount = _e.availableTimespansCount, timespansCount = _e.timespansCount, placeOptions = _e.placeOptions, timespanOptions = _e.timespanOptions, priceOptions = _e.priceOptions, bookerCountOptions = _e.bookerCountOptions, extraPrices = _e.extraPrices, categories = _e.categories, schedulingDateRange = _e.schedulingDateRange, schedulingTimeRange = _e.schedulingTimeRange, requiresPriceSelection = _e.requiresPriceSelection;
        var getRequiredValidator = function (required) { return (required ? { validate: [{ type: validatorTypes.REQUIRED }] } : {}); };
        var getSelectOption = function (options, name, label, placeholder, otherOptions, translate) {
            if (placeholder === void 0) { placeholder = ""; }
            if (otherOptions === void 0) { otherOptions = {}; }
            if (translate === void 0) { translate = true; }
            return (__assign(__assign(__assign({ name: deriveNameWithPrefix(name), label: translate ? i18next.t(label) : label, options: options, placeholder: placeholder }, otherOptions), getRequiredValidator(otherOptions.required)), { component: componentTypes.SELECT }));
        };
        var allSelects = [];
        var resetCartItems = (_a = {},
            _a[getCartItemQuantityPath(ROOT_CART_ITEM_INDEX)] = null,
            _a[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".onDate"] = null,
            _a[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking_slot"] = null,
            _a[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".bookingSlot"] = null,
            _a[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.from"] = null,
            _a[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.to"] = null,
            _a[deriveNameWithPrefix("booking_data.has_separate_bill_data")] = undefined,
            _a);
        // Get Places Select
        if (!!options.show_place_select && placeOptions.length) {
            allSelects.push(getSelectOption(placeOptions, "placeName", "bookcart.place", i18next.t("bookcart.select_place"), {
                isHidden: placeOptions.length == 1,
                reset: function () {
                    var _a, _b;
                    (_b = (_a = _this.options).resetPageNumber) === null || _b === void 0 ? void 0 : _b.call(_a);
                    return __assign({ categoryNames: null }, resetCartItems);
                }
            }));
        }
        // Get multi category Select
        categories.forEach(function (categoryOptions, i) {
            if (categoryOptions.length <= 1)
                return;
            allSelects.push(getSelectOption(categoryOptions, "categoryNames[" + i + "]", "bookcart.course", i18next.t("bookcart.select_course_" + (i + 1)) || i18next.t("bookcart.select_course", { index: i + 1 }), {
                isHidden: categoryOptions.length <= 1,
                reset: function (state) {
                    var _a, _b;
                    (_b = (_a = _this.options).resetPageNumber) === null || _b === void 0 ? void 0 : _b.call(_a);
                    return __assign(__assign({}, onCategoryChange(i)(state)), resetCartItems);
                }
            }));
        });
        // Get Timespan Select
        if (this.options.showTimespanSearchAndSelect) {
            allSelects.push(this.getTimespanSearchAndSelect(form, options));
        }
        else {
            allSelects.push(getSelectOption(timespanOptions, TIMESPAN_ID_PATH, "bookcart.timespan", i18next.t("bookcart.select_timespan"), {
                required: true,
                isHidden: availableTimespansCount <= 0 || timespansCount <= 1,
                reset: resetCartItems,
            }));
        }
        // Get Customer Select
        if (this.options.isAdminIntegration && timespanId && this.options.showTimespanSearchAndSelect && availableTimespansCount > 0) {
            allSelects.push(this.getCustomerSearchAndSelect(form));
        }
        if (availableTimespansCount === 0) {
            allSelects.push({
                name: "no-course-timespans-to-select",
                text: NoDataToDisplay({ message: i18next.t("bookcart.all_timespans_booked_out") }),
                className: BLOCK,
                component: componentTypes.PLAIN_TEXT
            });
        }
        // Get Booker Count select
        {
            var isDisabled = requiresPriceSelection && bookerCountOptions.length <= 1;
            var waitlistHiddenProps = timespanId
                && !requiresPriceSelection
                && bookerCountOptions.length === 1
                && this.courseTimespans().findById(timespanId).hasLastBookingSlot
                ? {
                    hideReason: NoDataToDisplay({ message: i18next.t("bookcart.one_participant_left_waitlist") }),
                    hideReasonClassNamee: "ws-waitlist-one-participant"
                } : {};
            allSelects.push(getSelectOption(bookerCountOptions, getCartItemQuantityPath(rootCartItemIndex), "bookcart.participant", i18next.t("bookcart.select_bookers_count"), __assign(__assign({ required: bookerCountOptions.length > 0, isHidden: !timespanId || (!requiresPriceSelection && bookerCountOptions.length <= 1), showDefaultOption: requiresPriceSelection || bookerCountOptions.length <= 0, disabled: isDisabled }, waitlistHiddenProps), { reset: (_b = {},
                    _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking_slot"] = null,
                    _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".bookingSlot"] = null,
                    _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.from"] = null,
                    _b[getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.to"] = null,
                    _b) })));
        }
        // Get Price Select
        allSelects.push(getSelectOption(priceOptions, getCartItemPriceIdPath(rootCartItemIndex), "bookcart.price", i18next.t("bookcart.select_price"), {
            required: priceOptions.length > 0 || requiresPriceSelection,
            isHidden: priceOptions.length <= 1
        }));
        if (requiresPriceSelection && !!getBookersCount(form) && priceOptions.length <= 0) {
            allSelects.push({
                name: "no-price-to-select",
                text: NoDataToDisplay({ message: i18next.t("bookcart.all_prices_booked_out") }),
                className: BLOCK,
                component: componentTypes.PLAIN_TEXT
            });
        }
        // Get Show Price Description
        var priceDescription = priceId && ((_c = this.prices().findById(priceId)) === null || _c === void 0 ? void 0 : _c.get("presented.body"));
        if (!this.options.isAdminIntegration && priceId && (priceDescription === null || priceDescription === void 0 ? void 0 : priceDescription.trim())) {
            allSelects.push({
                name: "priceDescription",
                className: PRICE_DESCRIPTION,
                component: componentTypes.PLAIN_TEXT,
                text: (_d = this.prices().findById(priceId)) === null || _d === void 0 ? void 0 : _d.get("presented.body")
            });
        }
        // Get Extra Prices
        var extraPriceAsCheckbox = get(this.options, "max_quantity_articles") < 2 && get(this.options, "max_quantity_courses") < 2;
        extraPrices.forEach(function (extraPriceSelect, index) {
            var label = extraPriceSelect.label, options = extraPriceSelect.options, id = extraPriceSelect.id, otherProps = __rest(extraPriceSelect, ["label", "options", "id"]);
            var name = getCartItemPath(rootCartItemIndex + index + 1) + ".position.quantity";
            if (extraPriceAsCheckbox) {
                name = deriveNameWithPrefix(name);
                set(form, name, +get(form, name));
                allSelects.push(__assign(__assign({ name: name,
                    label: label, component: componentTypes.CHECKBOX, className: "extra-prices" }, otherProps), { value: "1", checked: +get(form, name) === 1, getDynamicValue: function (value) { return ({ key: name, value: String(Number(+get(form, name) === 0)) }); } }));
                return;
            }
            allSelects.push(getSelectOption(options, name, label, "0", __assign({ isInline: true, className: "extra-prices", reverse: !_this.options.isAdminIntegration, showDefaultOption: !_this.options.isAdminIntegration, isHidden: false }, otherProps), false));
        });
        if (requires_scheduling) {
            var dateFieldName = getCartItemPath(rootCartItemIndex) + ".onDate";
            var bookingSlotName_1 = getCartItemPath(rootCartItemIndex) + ".bookingSlot";
            allSelects.push(normalizeField({
                value: get(form, dateFieldName),
                title: i18next.t("bookcart.timeslots.select_time_slot_date") || i18next.t("bookcart.timeslots.select_time_slot"),
                name: dateFieldName,
                is_required: true,
                field_type_name: componentTypes.SELECT,
            }, {
                isHidden: schedulingDateRange.length < 1,
                placeholder: i18next.t("bookcart.timeslots.select_time_slot_date_placeholder"),
                getDynamicValue: function () { return ([
                    { key: bookingSlotName_1, value: null },
                    { key: getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.from", value: null },
                    { key: getCartItemPath(ROOT_CART_ITEM_INDEX) + ".booking.to", value: null },
                ]); },
                options: uniqBy(schedulingDateRange.map(function (date) {
                    return {
                        value: dateToString(date, "date"),
                        label: i18next.t("bookcart.timeslots.date_label", {
                            date: function () { return getDate(date); },
                            month: function () { return getDate(date); },
                            year: function () { return getDate(date); },
                            day: function () { return isToday(date) ? i18next.t("date.today") : isTomorrow(date) ? i18next.t("date.tomorrow") : dateFormat(date, "cccc"); },
                            value: function () { return dateFormat(date, i18next.t("date.date_format")); },
                            skipInterpolation: true
                        })
                    };
                }), function (_a) {
                    var value = _a.value;
                    return value;
                }),
            }));
            if (schedulingDateRange.length < 1) {
                allSelects.push({
                    name: "no-timeslots-to-select",
                    text: NoDataToDisplay({ message: i18next.t("bookcart.all_timespans_booked_out") }),
                    className: BLOCK,
                    component: componentTypes.PLAIN_TEXT
                });
            }
            allSelects.push(normalizeField({
                name: deriveNameWithPrefix(bookingSlotName_1),
                title: i18next.t("bookcart.timeslots.select_time_slot_time"),
                field_type_name: componentTypes.TIME_SLOT,
                is_required: true
            }, {
                isHidden: schedulingDateRange.length < 1,
                onDate: get(form, dateFieldName),
                showUnavailableTimeslots: !!this.options.scheduling_show_unavailable_times,
                includeDates: schedulingDateRange,
                slots: schedulingTimeRange,
            }));
        }
        return allSelects.filter(Boolean);
    };
    BookModelManager.prototype.getExtraPriceFields = function (form, _a) {
        var cartIndex = _a.cartIndex, timespanId = _a.timespanId, priceId = _a.priceId, participantKey = _a.participantKey;
        var participants = get(form, participantKey, []);
        var allCartItems = form.getCartItemsByTimespanId(timespanId, priceId);
        var rootCartItem = allCartItems.find(function (cartItem) { return cartItem.isRoot; });
        var extraPriceItems = allCartItems.filter(function (cartItem) { return !cartItem.isRoot; });
        var bookersCount = rootCartItem === null || rootCartItem === void 0 ? void 0 : rootCartItem.quantity;
        var salutations = keyBy(this.salutations().all().map(function (_a) {
            var id = _a.id, humanIdentifier = _a.humanIdentifier;
            return ({ id: id, label: humanIdentifier });
        }), "id");
        return extraPriceItems
            .map(function (item, index) {
            var _a = item || {}, priceId = _a.priceId, priceModel = _a.priceModel, isExtraPrice = _a.isExtraPrice, quantity = _a.quantity;
            var hideCourseTimespanParticipants = Number(quantity) === Number(bookersCount);
            if (!priceId || isExtraPrice || Number(quantity) <= 0)
                return null;
            if (hideCourseTimespanParticipants)
                return null;
            var fields = new Array(+quantity).fill(null).map(function (x, fieldIndex) {
                var fieldName = getCartItemPath(cartIndex + index + 1) + ".booking.personal_data_index";
                var rootItemName = getCartItemPath(cartIndex) + ".booking.personal_data_index";
                var selectedParticipants = get(form, rootItemName, []);
                var otherSelectedParticipantIndexes = get(form, fieldName, []).filter(function (x, index) { return selectedParticipants.includes(x) && index !== fieldIndex; }).map(function (x) { return +x; });
                var options = getParticipantsAsSelectOptions(participants, bookersCount, { otherSelectedParticipantIndexes: otherSelectedParticipantIndexes, salutations: salutations, selection: selectedParticipants[fieldIndex] }).filter(function (_a) {
                    var value = _a.value;
                    return selectedParticipants.includes(value);
                });
                if (hideCourseTimespanParticipants) {
                    set(form, fieldName, selectedParticipants.concat([]));
                    return null;
                }
                return normalizeField({
                    name: fieldName + "." + fieldIndex,
                    title: i18next.t("bookcart.participant_header", { index: fieldIndex + 1 }),
                    is_required: true,
                    field_type_name: "select"
                }, {
                    options: options
                });
            }).filter(Boolean);
            var name = "extra-timespans-" + index;
            return {
                title: priceModel === null || priceModel === void 0 ? void 0 : priceModel.get("presented.customerTitle"),
                description: i18next.t("bookcart.sub_event_help_text"),
                name: name,
                component: componentTypes.FIELD_SET,
                className: "extra-timespans " + name,
                fields: fields
            };
        }).filter(Boolean);
    };
    BookModelManager.prototype.addParticipantDropdown = function (form, participantForm, options) {
        var _this = this;
        var timespanId = options.timespanId;
        var priceId = get(options, "priceId");
        var rootItem = form.getCartItemsByTimespanId(timespanId, priceId).find(function (cartItem) { return cartItem.isRoot; });
        var bookersCount = rootItem === null || rootItem === void 0 ? void 0 : rootItem.quantity;
        var participants = get(form, options.participantNameKey, []);
        var isBillRecipientStepHidden = get(options, 'shouldHideBillRecipient', false);
        var salutations = keyBy(this.salutations().all().map(function (_a) {
            var id = _a.id, humanIdentifier = _a.humanIdentifier;
            return ({ id: id, label: humanIdentifier });
        }), "id");
        var hasDefaultParticipantdata = form.hasParticipantData() && options.cart_index === 0;
        participantForm.fields.forEach(function (_a, index) {
            var fields = _a.fields;
            if (!hasDefaultParticipantdata && isBillRecipientStepHidden && index === 0)
                return;
            var pathToPersonalData = options.pathToPersonalData;
            var name = pathToPersonalData + "." + index;
            var useSearchAndSelect = _this.options.showParticipantSearchAndSelect;
            var personalDataIndex = get(form, name, null);
            var newParticipantReference = "created_new_participant." + personalDataIndex;
            var otherSelectedParticipantIndexes = get(form, pathToPersonalData, []).filter(function (x, i) { return x && i !== index; }).map(function (x) { return +x; });
            var referenceField = getReferenceFieldPath(get(options, "formGroupId"));
            var getReferenceFieldAbsolutePathPath = function (index) { return options.participantNameKey + "." + index + "." + referenceField; };
            var referenceFieldPath = getReferenceFieldAbsolutePathPath(personalDataIndex);
            var createNewParticipant = get(form, newParticipantReference) !== name;
            var participantsOptions = getParticipantsAsSelectOptions(participants, bookersCount, {
                index: index,
                selection: personalDataIndex,
                form: form,
                salutations: salutations,
                otherSelectedParticipantIndexes: otherSelectedParticipantIndexes,
                createNewParticipant: createNewParticipant,
                customerList: _this.options.customerData,
                defaultIndices: (rootItem === null || rootItem === void 0 ? void 0 : rootItem.defaultIndices) || [],
                // exclude: get(form, "booking_data.has_separate_bill_data") ? [get(form, "booking_data.bill_receiver_index")] : [],
            });
            if (participantsOptions.length <= 1)
                return;
            if (personalDataIndex === null || (+_this.options.hide_all_participant_forms === 1 && get(form, referenceFieldPath) !== name)) {
                fields.splice(0);
            }
            fields.unshift((normalizeField({
                name: name,
                title: i18next.t("bookcart.select_participant_title"),
                is_required: false,
                field_type_name: useSearchAndSelect ? componentTypes.SEARCH_N_SELECT : componentTypes.SELECT,
                placeholder: i18next.t("bookcart.select_participant_placeholder"),
            }, {
                // isHidden: participantsOptions.length <= 1,
                showDefaultOption: false,
                allowBlank: useSearchAndSelect ? false : undefined,
                labelKey: useSearchAndSelect ? "label" : null,
                query: useSearchAndSelect ? get(form, getSearchAndSelectName(name)) : undefined,
                options: participantsOptions,
                reset: function (state, name) {
                    var _a;
                    return (createNewParticipant && !get(state, name) ? (_a = {}, _a[newParticipantReference] = true, _a) : {});
                }
            })));
        });
    };
    BookModelManager.prototype.addCustomerSearchAndSelect = function (form, participantForm) {
        if (!this.options.showCustomerSearchAndSelect)
            return null;
        var customerSearchAndSelect = this.getCustomerSearchAndSelect(form);
        participantForm.fields.forEach(function (_a, index) {
            var fields = _a.fields;
            fields.unshift(customerSearchAndSelect);
        });
    };
    BookModelManager.prototype.getCustomerSearchAndSelect = function (form) {
        var _this = this;
        if (!this.options.showCustomerSearchAndSelect)
            return null;
        var name = "customerIdParticipant";
        var timespanIds = get(form, "booking_data.cart_items", []).filter(function (cartItem) { return get(cartItem, "position.parent_price_id") === null; }).map(function (cartItem) { return get(cartItem, "booking.course_timespan_id"); }).filter(Boolean);
        // const timespans = this.courseTimespans().whereIn("id", timespanIds);
        if (!timespanIds.length) {
            return null;
        }
        // const formIds = (timespans.all() as CourseTimespanModel[]).map((t) => t.topFormItem()?.id).filter(Boolean).join(",")
        var initialValue = form.customerIdParticipant;
        return normalizeField({
            name: name,
            title: i18next.t("bookcart.select_customer"),
            field_type_name: componentTypes.SEARCH_N_SELECT,
        }, {
            initialValue: initialValue,
            clearValue: "",
            labelKey: "displayTitle",
            showDefaultOption: false,
            isFetchOptionsDispatchAction: true,
            query: get(form, getSearchAndSelectName(name)),
            isLoading: this.options.isLoadingCustomers,
            reset: function (state, name, value) {
                var _a = (value === null || value === void 0 ? void 0 : value.split("_")) || ["", ""], customerId = _a[0], participantIndex = _a[1];
                return {
                    form_data: get(_this.options, "customerData." + customerId + ".form_data", { form_group: {} }),
                    created_new_participant: {},
                    searchAndSelect: {},
                    customerId: customerId,
                    "booking_data.cart_items.0.booking.personal_data_index": [participantIndex]
                };
            },
            hasRemoteSource: true,
            fetchOptions: function (_a) {
                var query = _a.query;
                return getCustomerList({ query: query, timespanId: timespanIds[0] || "", customerId: form.bookingId && form.customerId }, _this.options.apiCancelToken);
            },
            options: get(this.options, "customerList", []).reduce(function (allOptions, _a) {
                var id = _a.id, _b = _a.names, names = _b === void 0 ? [] : _b;
                var customerName = names[0], allParticipants = names.map(function (participantName, index) {
                    if (!participantName)
                        return null;
                    return {
                        label: index === 0 ? "<strong>" + customerName + "</strong>" : i18next.t("bookcart.customer_participant", { customerName: customerName, participantName: participantName }),
                        displayTitle: index === 0 ? "" + customerName : i18next.t("bookcart.customer_participant", { customerName: customerName, participantName: participantName }),
                        value: id + "_" + index
                    };
                });
                return allOptions.concat(allParticipants);
            }, [{
                    label: i18next.t("bookcart.new_customer"),
                    displayTitle: i18next.t("bookcart.new_customer"),
                    value: ""
                }]).filter(Boolean),
        });
    };
    BookModelManager.prototype.getDifferingParticipantsCheckbox = function (form) {
        var name = "hasDifferingParticipants";
        var translationLabel = get(form, name) ? "register_differing_participants_help_text_checked" : "register_differing_participants_help_text_unchecked";
        return {
            name: name,
            label: i18next.t("cart.register_differing_participants"),
            className: getClassName(STEP_META, REGISTER_DIFFERENT_PARTICIPANTS),
            children: i18next.t("cart." + translationLabel),
            component: componentTypes.CHECKBOX,
            getDynamicValue: function (_a, form) {
                var value = _a.value;
                return [
                    { key: name, value: value },
                    { key: "created_new_participant", value: {} },
                ];
            }
        };
    };
    BookModelManager.prototype.getParticipantStep = function (form, validationErrors) {
        var _this = this;
        var timespan = (this.courseTimespans().findById(+getTimespanId(form)) || this.courseTimespans().first());
        var formGroup = timespan === null || timespan === void 0 ? void 0 : timespan.participantFormItem().formGroup();
        var participantNameKey = formGroup.getRelationName() || "";
        var hasDefaultData = get(this.options, "isAdminIntegration", false) && form.hasDefaultParticipantData();
        var mustHaveDifferingParticipants = form.mustHaveDifferingParticipants;
        var shouldSplitForm = mustHaveDifferingParticipants || get(form, "hasDifferingParticipants", false);
        var differingParticipantsCheckbox = mustHaveDifferingParticipants ? null : this.getDifferingParticipantsCheckbox(form);
        var salutations = keyBy(this.salutations().all().map(function (_a) {
            var id = _a.id, humanIdentifier = _a.humanIdentifier;
            return ({ id: id, label: humanIdentifier });
        }), "id");
        var stepNameAsTimespanTitle = function (cartItem) {
            var _a, _b;
            var thisTimespan = cartItem.timespan;
            var customerPrices = thisTimespan === null || thisTimespan === void 0 ? void 0 : thisTimespan.customerPrices();
            var timespanTitle = (customerPrices === null || customerPrices === void 0 ? void 0 : customerPrices.size) === 1 ? "" : thisTimespan === null || thisTimespan === void 0 ? void 0 : thisTimespan.getAsTitle([], { placement: "bookcart", titleKey: "timespan_format", hidePrice: true });
            var priceTitle = ((_a = cartItem.priceModel) === null || _a === void 0 ? void 0 : _a.get("presented.customerTitle")) || "";
            var price = ((_b = cartItem.priceModel) === null || _b === void 0 ? void 0 : _b.getSubPriceSumTotalFormatted()) || "";
            return i18next.t("cart.timespan_header", {
                timespan_title: timespanTitle,
                price_title: priceTitle,
                base_price: price
            }).trim();
        };
        var rootCartItems = form.rootCartItems;
        var fields = form.cartItems.reduce(function (fieldset, cartItem, i) {
            var _a;
            if (!cartItem.isRoot) {
                return fieldset;
            }
            var priceId = cartItem.priceId;
            var timespanId = cartItem.timespanId;
            var thisTimespan = cartItem.timespan;
            if (!thisTimespan) {
                return fieldset;
            }
            if (!thisTimespan.shouldCollectParticipantInformation) {
                return fieldset;
            }
            var hideBillRecipeintStep = thisTimespan.shouldHideBillRecipient && (!_this.options.isAdminIntegration || hasDefaultData || i === 0);
            var participantFormGroup = thisTimespan === null || thisTimespan === void 0 ? void 0 : thisTimespan.participantFormItem().formGroup();
            var groupName = participantFormGroup === null || participantFormGroup === void 0 ? void 0 : participantFormGroup.getItemName();
            var pathToPersonalData = getCartItemPersonalDataPath(i);
            var participantIndices = get(form, pathToPersonalData, []);
            var participantForm = participantFormGroup.getAsParticipantGroup(form, validationErrors, __assign(__assign({}, _this.options), { priceId: priceId,
                timespanId: timespanId,
                hideBillRecipeintStep: hideBillRecipeintStep,
                salutations: salutations, cart_index: i, participantIndices: participantIndices,
                form: form }));
            if ((rootCartItems.length > 1 || form.hasParticipantData()) && _this.options.showParticipantDropdown) {
                _this.addParticipantDropdown(form, participantForm, {
                    priceId: priceId,
                    timespanId: timespanId,
                    hideBillRecipeintStep: hideBillRecipeintStep,
                    cart_index: i,
                    pathToPersonalData: pathToPersonalData,
                    participantNameKey: participantNameKey,
                    formGroupId: participantFormGroup.id,
                    shouldHideBillRecipient: hideBillRecipeintStep
                });
            }
            _this.addCustomerSearchAndSelect(form, participantForm);
            var extraPriceFields = _this.getExtraPriceFields(form, { cartIndex: i, timespanId: timespanId, priceId: priceId, participantKey: participantNameKey });
            var no_accordion = true; //!this.options.collapseValidParticipantsByDefault && this.options.no_accordion;
            var participantStep = setParticipantProps(__assign(__assign({}, participantForm), { fields: participantForm.fields, title: _this.options.displayTimespanTitleInParticipants ? stepNameAsTimespanTitle(cartItem) : participantForm.title }), {
                name: groupName, className: no_accordion ? PARTICIPANT_GROUP_FLAT : PARTICIPANT_GROUP
            }, {
                no_accordion: no_accordion,
                accordion_all_open: _this.options.collapseValidParticipantsByDefault || _this.options.accordion_all_open,
                fieldClassName: _this.options.isAdminIntegration ? INLINE_FIELDS : ""
            });
            (_a = participantStep.fields).push.apply(_a, extraPriceFields);
            var participantField = __assign(__assign({}, participantStep), { name: participantStep.name + "." + i });
            var sanitizedForm = !shouldSplitForm
                ? participantField
                : participantFormGroup.getStepData({
                    name: "cartitem-" + i,
                    title: _this.options.originalParticipantStepName ? undefined : stepNameAsTimespanTitle(cartItem),
                    description: participantFormGroup.get("presented.body"),
                    fields: [
                        i === 0 ? differingParticipantsCheckbox : null,
                        participantStep
                    ].filter(Boolean)
                });
            return fieldset.concat(sanitizedForm);
        }, []).filter(Boolean);
        if (fields.length === 0) {
            return [];
        }
        if (shouldSplitForm)
            return fields.map(function (field) { return (__assign(__assign({}, field), { groupName: i18next.t("bookcart.enter_participant_information") })); });
        var participantForms = [fields[0]];
        return formGroup.getStepData({
            name: "cartitem-0",
            description: formGroup.get("presented.body"),
            fields: __spreadArray([differingParticipantsCheckbox], participantForms).filter(Boolean)
        });
    };
    BookModelManager.prototype.getBillRecipientStep = function (form, validationErrors) {
        var _a;
        var shouldCollectParticipantInfoUnique = uniq(form.rootCartItems.map(function (_a) {
            var timespan = _a.timespan;
            return timespan === null || timespan === void 0 ? void 0 : timespan.shouldCollectParticipantInformation;
        }));
        var timespan = (((_a = form.rootCartItems[0]) === null || _a === void 0 ? void 0 : _a.timespan) || this.courseTimespans().first());
        var hasDefaultData = get(this.options, "isAdminIntegration", false) && form.hasDefaultParticipantData();
        var hasFixedBillRecipient = form.deriveFixedBillRecipientIndexFromCart() !== null;
        var shouldCollectParticipantInformation = shouldCollectParticipantInfoUnique.length === 1 ? shouldCollectParticipantInfoUnique[0] : hasFixedBillRecipient;
        var hideBillRecipeintStep = hasDefaultData ? false : shouldCollectParticipantInformation && hasFixedBillRecipient;
        var hideSeparateBillReceipient = shouldCollectParticipantInformation && form.hideSeparateBillReceipient;
        var formGroup = timespan === null || timespan === void 0 ? void 0 : timespan.billReceiverFormItem().formGroup();
        var participantNameKey = (formGroup === null || formGroup === void 0 ? void 0 : formGroup.getRelationName()) || "";
        var forceSeparateBillRecipient = hideSeparateBillReceipient || form.hasSeparateBillRecipient;
        var excludedIndices = form.deriveExcludedBillRecipientIndices();
        var participants = get(form, participantNameKey, [])
            .map(function (participant, index) { return (__assign(__assign({}, participant), { index: String(index) })); })
            .filter(function (_a) {
            var index = _a.index;
            return forceSeparateBillRecipient ? !excludedIndices.includes(index) : excludedIndices.includes(index);
        });
        var salutations = keyBy(this.salutations().all().map(function (_a) {
            var id = _a.id, humanIdentifier = _a.humanIdentifier;
            return ({ id: id, label: humanIdentifier });
        }), "id");
        return __assign(__assign({}, formGroup.getAsBillRecipientGroup(form, validationErrors, participants, {
            timespanId: timespan.id,
            hasFixedBillRecipient: hasFixedBillRecipient,
            shouldCollectParticipantInformation: shouldCollectParticipantInformation,
            hidePersonalData: hasDefaultData || hideSeparateBillReceipient,
            salutations: salutations,
            forceSeparateBillRecipient: forceSeparateBillRecipient,
            hideBillRecipeintStep: hideBillRecipeintStep
        })), { name: "bill-recipient-form", hideStep: hideBillRecipeintStep });
    };
    BookModelManager.prototype.getFormSteps = function (form, validationErrors) {
        var _this = this;
        var _a, _b, _c, _d;
        var timespan_id = ((_a = form.rootCartItems[0]) === null || _a === void 0 ? void 0 : _a.timespanId) || getTimespanId(form) || -1;
        var timespan = (this.courseTimespans().findById(timespan_id) || this.courseTimespans().first());
        if (!timespan)
            return [];
        var waitingListForm = this.getWaitingListEntityFormItem(form);
        var participantFormItemId = (_b = timespan.participantFormItem()) === null || _b === void 0 ? void 0 : _b.get("id");
        var billerFormItem = timespan.billReceiverFormItem();
        var billReceiverFormItemId = billerFormItem === null || billerFormItem === void 0 ? void 0 : billerFormItem.get("id");
        var consentFormItemId = (_c = timespan.consentFormItem()) === null || _c === void 0 ? void 0 : _c.get("id");
        var shouldCollectParticipantInformation = form.shouldCollectParticipantInfo;
        var billRecipientStep = this.getBillRecipientStep(form, validationErrors);
        var formItems = (waitingListForm === null || waitingListForm === void 0 ? void 0 : waitingListForm.all()) || ((_d = timespan.topFormItem().formGroup()) === null || _d === void 0 ? void 0 : _d.formItems().all()) || [];
        return formItems.reduce(function (allSteps, formItem) {
            var _a;
            var formGroup = formItem.formGroup();
            if (formItem.id === participantFormItemId) {
                if (!shouldCollectParticipantInformation)
                    return allSteps;
                return allSteps.concat(_this.getParticipantStep(form, validationErrors));
            }
            if (formItem.id === billReceiverFormItemId) {
                return allSteps.concat(billRecipientStep);
            }
            if (formItem.id === consentFormItemId) {
                return allSteps.concat(_this.getConsentStep(form, validationErrors));
            }
            if (formItem.id === ((_a = waitingListForm === null || waitingListForm === void 0 ? void 0 : waitingListForm.first()) === null || _a === void 0 ? void 0 : _a.id)) {
                return allSteps.concat(formGroup.getWaitingListForm(form, validationErrors, {}));
            }
            return allSteps.concat(formGroup.getFormGroup(form, validationErrors));
        }, []).filter(Boolean);
    };
    BookModelManager.prototype.getPayableAmount = function (form) {
        return this.prices().transducePrices(form, function (cartItemsObject) {
            return function (sum, m) {
                var count = cartItemsObject[m.id];
                return sum + (m.get("priceIncludingSubPrices") * count);
            };
        }, 0);
    };
    BookModelManager.prototype.hasNoticeOnlyPrice = function (form) {
        return this.prices().transducePrices(form, function () {
            return function (noticeOnly, m) {
                if (noticeOnly || !!m.get("only_notice"))
                    return true;
                return m.subPrices().all().some(function (sp) { return sp.get("only_notice"); });
            };
        }, false);
    };
    BookModelManager.prototype.getSubmitButtonLabel = function (form, options) {
        if (options === void 0) { options = {}; }
        if (this.options.isAdminIntegration)
            return "bookcart.complete_booking";
        if (form.toWaitList)
            return "bookcart.add_to_waiting_list";
        var finalizeBillWithComment = get(options, "finalize_bill_with_comment") === 1;
        var finalDeduction = {
            hasPayableAmount: this.getPayableAmount(form) > 0,
            hasNoticeOnlyPrice: this.hasNoticeOnlyPrice(form),
            hasComment: !!getComments(form)
        };
        var willCheckout = !finalDeduction.hasNoticeOnlyPrice && (!finalDeduction.hasComment || finalizeBillWithComment);
        var checkoutLabel = finalDeduction.hasPayableAmount ? "bookcart.checkout" : "bookcart.button_book_for_free";
        return willCheckout ? checkoutLabel : "bookcart.submit";
    };
    BookModelManager.prototype.getSepaForm = function (form, validationErrors) {
        if (form === void 0) { form = {}; }
        if (validationErrors === void 0) { validationErrors = null; }
        var formGroups = this.formGroups().filter(function (x) { return x.get("name") === "sepamandate"; });
        return formGroups.all().map(function (m) { return m.getFormGroup(form, validationErrors, componentTypes.FIELD_SET); });
    };
    BookModelManager.prototype.getConsentForm = function () {
        var formItem = this.formItems().filter(function (x, index) { return index === 0; });
        return formItem.getFields({}, null);
    };
    BookModelManager.prototype.getWaitlistForm = function () {
        var formItem = this.formItems().filter(function (x, index) { return index === 0; });
        return formItem.getFields({}, null);
    };
    BookModelManager.prototype.getConsentStep = function (form, validationErrors) {
        var _this = this;
        var _a, _b, _c;
        var consentFormItem = this.formItems().all().find(function (formItem) { return formItem.isConsent; });
        var firstConsentFormItem = (_c = (_b = (_a = form.rootCartItems[0]) === null || _a === void 0 ? void 0 : _a.timespan) === null || _b === void 0 ? void 0 : _b.consentFormItem()) === null || _c === void 0 ? void 0 : _c.formGroup();
        var formItemIds = form.rootCartItems.reduce(function (all, rootItem) { var _a, _b; return all.concat((_b = (_a = rootItem.timespan) === null || _a === void 0 ? void 0 : _a.consentFormItem()) === null || _b === void 0 ? void 0 : _b.id); }, []).filter(Boolean);
        var map = new Map();
        var formItems = this.formItems().whereIn("id", formItemIds).all();
        var setFieldExists = function (formItem) {
            var key = formItem.isFormGroup ? formItem.formGroup().get("related.consent.value") : formItem.get("related.consent.value");
            var exists = map.has(key);
            map.set(key, true);
            return !exists;
        };
        var getFormField = function (formItem) {
            return (_this.formItems().filter(function (_a) {
                var id = _a.id;
                return id === (formItem === null || formItem === void 0 ? void 0 : formItem.id);
            })).getFields(form, validationErrors, "form_data", 0);
        };
        var fields = formItems.reduce(function (allFields, formItem) {
            if (!formItem.isFormGroup) {
                if (setFieldExists(formItem)) {
                    return allFields.concat(getFormField(formItem));
                }
                return allFields;
            }
            var fieldsAndGroups = (formItem.formGroup().formItems().all()).reduce(function (formItems, formItem) {
                if (!formItem.isFormGroup) {
                    if (setFieldExists(formItem)) {
                        return formItems.concat(getFormField(formItem));
                    }
                    return formItems;
                }
                ;
                var formGroup = formItem.formGroup();
                var fields = (formGroup.formItems().filter(setFieldExists)).getFields(form, validationErrors, "form_data");
                return fields.length ? formItems.concat(formGroup.getStepData({ fields: fields })) : formItems;
            }, []);
            return allFields.concat(fieldsAndGroups);
        }, []);
        if (fields.length === 0) {
            return [];
        }
        return [{
                name: "consent-form",
                component: componentTypes.FIELD_SET,
                title: firstConsentFormItem === null || firstConsentFormItem === void 0 ? void 0 : firstConsentFormItem.get("title"),
                description: firstConsentFormItem === null || firstConsentFormItem === void 0 ? void 0 : firstConsentFormItem.get("presented.body"),
                fields: [].concat(consentFormItem === null || consentFormItem === void 0 ? void 0 : consentFormItem.getWrittenConsentCheckbox(form), fields, consentFormItem === null || consentFormItem === void 0 ? void 0 : consentFormItem.getSaveParticipantCheckbox(form))
            }];
        // return form.rootCartItems[0]?.timespan?.consentFormItem()?.formGroup().getFields(form, validationErrors);
    };
    BookModelManager.prototype.getCertificateDownloadsForm = function () {
        return this.formGroups().all().map(function (formGroup) { return formGroup.getFormGroup(); });
    };
    BookModelManager.prototype.mustHaveDifferingParticipants = function (form) {
        var cartItems = form.rootCartItems;
        return form.hasTimespanWithoutParticipantForm
            || cartItems.length <= 1
            || cartItems.some(function (cartItem) {
                return cartItem.participantFormGroupId !== cartItems[0].participantFormGroupId
                    || cartItem.quantity !== cartItems[0].quantity
                    || form.getCartItemsByTimespanId(cartItem.timespanId, cartItem.priceId)
                        .some(function (extraPrice) { return extraPrice.isExtraArticle && +extraPrice.quantity > 0; });
            });
    };
    BookModelManager.prototype.deriveCartForm = function (form, cartItems) {
        // TODO: pending
        var cartForm = merge({}, { booking_data: { cart_items: cartItems } }, form);
        if (this.options.showAvailableTimespansOnly) {
            var availableTimespans_1 = this.courseTimespans().getAvailableTimespans();
            var availablePrices_1 = this.prices();
            cartForm.booking_data.cart_items = cartForm.booking_data.cart_items.filter(function (cartItem) {
                if (!cartItem.booking) {
                    return availablePrices_1.findById(cartItem.position.price_id);
                }
                return availableTimespans_1.findById(cartItem.booking.course_timespan_id);
            });
        }
        return cartForm;
    };
    BookModelManager.prototype.getCartTotal = function (cart) {
        var _this = this;
        if (cart === void 0) { cart = []; }
        return cart
            .reduce(function (sumTotal, cartItem) {
            var priceId = get(cartItem, "position.price_id");
            var quantity = +get(cartItem, "position.quantity");
            var priceModel = _this.prices().findById(priceId);
            if (!priceModel || !quantity)
                return sumTotal;
            return sumTotal + ((priceModel === null || priceModel === void 0 ? void 0 : priceModel.priceIncludingSubPrices) * quantity);
        }, 0);
    };
    BookModelManager.prototype.getCartItemAsField = function (rootCartItem, _a) {
        var _b = _a.placement, placement = _b === void 0 ? '' : _b, index = _a.index, _c = _a.extraPrices, extraPrices = _c === void 0 ? [] : _c;
        var priceId = rootCartItem.priceId;
        var timespanModel = this.courseTimespans().getAvailableTimespans().findById(rootCartItem.timespanId);
        var priceModel = this.prices().findById(priceId);
        var quantity = rootCartItem.quantity;
        var totalAmount = (priceModel === null || priceModel === void 0 ? void 0 : priceModel.priceIncludingSubPrices) * +quantity;
        var name = getCartItemQuantityPath(index);
        var courseMeta = (timespanModel === null || timespanModel === void 0 ? void 0 : timespanModel.id) ? {
            defaultTitle: "bookcart.title",
            component: componentTypes.COURSE_META,
            timespanId: timespanModel === null || timespanModel === void 0 ? void 0 : timespanModel.id,
            showTitle: false,
            name: null,
        } : null;
        return {
            index: index,
            name: name,
            paginated: false,
            amount: totalAmount,
            className: CART_ITEM,
            parentNode: true,
            title: timespanModel ? timespanModel.getAsTitle([], { placement: placement || undefined }, { priceId: priceId }) : i18next.t("cart.item_no_longer_available"),
            price: timespanModel ? priceModel === null || priceModel === void 0 ? void 0 : priceModel.getSubPriceSumTotalFormatted() : null,
            total: timespanModel ? priceModel === null || priceModel === void 0 ? void 0 : priceModel.formatPrice(totalAmount) : null,
            quantity: timespanModel ? quantity : null,
            component: componentTypes.CART_TABLE_ROW_ITEM,
            fields: !timespanModel ? [] : [{
                    name: name + ".row",
                    component: componentTypes.FIELD_SET,
                    fields: __spreadArray([
                        courseMeta
                    ], this.getEventForm({ booking_data: { cart_items: __spreadArray([rootCartItem], extraPrices) } }, __assign({ placement: placement }, this.options), index).filter(function (_a) {
                        var name = _a.name;
                        return name.includes("onDate") || ["priceDescription", "quantity", "bookingSlot"].some(function (prop) { return name.endsWith(prop); });
                    })).filter(Boolean)
                }]
        };
    };
    BookModelManager.prototype.getCartItemExtraPriceAsField = function (item, index) {
        var priceModel = item.isBookedOut ? null : this.prices().findById(get(item, "position.price_id", null));
        var quantity = +get(item, "position.quantity", 0);
        var totalAmount = (priceModel === null || priceModel === void 0 ? void 0 : priceModel.priceIncludingSubPrices) * quantity;
        return {
            name: getCartItemQuantityPath(index),
            index: index,
            className: CART_EXTRA_ITEM,
            amount: totalAmount || null,
            title: priceModel ? priceModel.get("presented.customerTitle") : i18next.t("cart.item_no_longer_available"),
            price: priceModel ? priceModel.getSubPriceSumTotalFormatted() : null,
            total: priceModel ? priceModel.formatPrice(totalAmount) : null,
            quantity: item.isBookedOut ? null : quantity,
            parentNode: false,
            component: componentTypes.CART_TABLE_ROW_ITEM,
            fields: []
        };
    };
    BookModelManager.prototype.getCartItemsAsFields = function (form, _a) {
        var _this = this;
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.placement, placement = _d === void 0 ? '' : _d;
        var extraPricesByParentPriceId = groupBy(form.extraPrices, "position.parent_price_id");
        var fields = ((_b = form.cartItems) === null || _b === void 0 ? void 0 : _b.reduce(function (flattenedFields, cartItem, index) {
            var extraPrices = extraPricesByParentPriceId[cartItem.priceId] || [];
            if (cartItem.isRoot) {
                return flattenedFields.concat(_this.getCartItemAsField(cartItem, { placement: placement, index: index, extraPrices: extraPrices }));
            }
            if (+cartItem.quantity <= 0) {
                return flattenedFields;
            }
            return flattenedFields.concat(_this.getCartItemExtraPriceAsField(cartItem, index));
        }, [])) || [];
        return fields;
    };
    BookModelManager.prototype.getCartForm = function (form) {
        return {
            name: "cart",
            isGrossTax: !!this.options.is_gross_tax,
            component: componentTypes.CART_TABLE,
            fields: this.getCartItemsAsFields(form, { placement: 'cart' })
        };
    };
    BookModelManager.prototype.getCancelBookingForm = function (_a) {
        var _b, _c, _d;
        var formName = _a.formName;
        var fields = this.formGroups().all().map(function (formGroup) { return formGroup.getFormGroup(); }), createdAt = (_b = this.courseParticipants().first()) === null || _b === void 0 ? void 0 : _b.get("created_at");
        createdAt = createdAt && dateFormat(parseISO(createdAt.date), i18next.t("date.date_time_format"));
        (_c = fields === null || fields === void 0 ? void 0 : fields[0]) === null || _c === void 0 ? void 0 : _c.fields.unshift({
            component: componentTypes.COURSE_META,
            paginated: false,
            courseTimespan: this.courseTimespans().first(),
            timespanId: (_d = this.courseTimespans().first()) === null || _d === void 0 ? void 0 : _d.id,
            placement: "cancel_booking",
            defaultDescription: createdAt ? i18next.t("cancel_booking.created_at", { created_at: createdAt, }) : "",
            name: "cancelBooking-meta",
            hidePrice: true,
            showDescription: false,
            displayTitleAs: "h4",
            className: CONFIRM_CANCEL_BOOKING_WRAPPER,
            formName: formName,
        });
        return fields;
    };
    BookModelManager.prototype.getCmsFields = function (_a) {
        var model_name = _a.model_name;
        try {
            return this.getCollection(model_name).all().map(function (model) { return ({
                name: model.name,
                component: componentTypes.CARD,
                title: model.get("presented.page_title"),
                description: model.get("presented.body"),
                fields: []
            }); });
        }
        catch (e) {
            console.error({ e: e });
            return [];
        }
    };
    return BookModelManager;
}(BeeModelManager));
export { BookModelManager };
export var getBookManager = function (entities, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var modelTypes = (_a = {},
        _a[EntitiesEnum.COURSE_TIMESPANS] = CourseTimespanModel,
        _a[EntitiesEnum.COURSES] = CourseModel,
        _a[EntitiesEnum.TAGS] = BookModel,
        _a[EntitiesEnum.CONSENT] = ConsentModel,
        _a[EntitiesEnum.USERS] = UserModel,
        _a[EntitiesEnum.PLACES] = PlaceModel,
        _a[EntitiesEnum.PRICES] = PriceModel,
        _a[EntitiesEnum.FORM_GROUPS] = FormGroupModel,
        _a[EntitiesEnum.FORM_FIELDS] = FormFieldModel,
        _a[EntitiesEnum.FORM_ITEMS] = FormItemModel,
        _a[EntitiesEnum.COUNTRIES] = CountryModel,
        _a[EntitiesEnum.SALUTATIONS] = SalutationModel,
        _a[EntitiesEnum.OUTGOING_MESSAGES] = OutgoingMessageModel,
        _a[EntitiesEnum.SCHEDULING_TIME_RANGES] = SchedulingTimeRangeModel,
        _a[EntitiesEnum.QUANTITY_STEPS] = CourseTimespansQuantityStepModel,
        _a[EntitiesEnum.COURSE_PARTICIPANTS] = BookModel,
        _a[EntitiesEnum.SELECT_OPTIONS] = BookModel,
        _a[EntitiesEnum.COURSE_APPOINTMENTS] = AppointmentModel,
        _a);
    return new BookModelManager(modelTypes, mergeEntities(entities), options);
};
